/* eslint-disable no-param-reassign */
export default [
  {
    text: '组件名称',
    name: 'name',
  },
  {
    inputType: 'select',
    text: '类型',
    name: 'videoType',
    defaultValue: 1,
    options: [
      {
        text: '内嵌视频',
        value: 1,
      },
      {
        text: '弹出视频',
        value: 2,
      },
      {
        text: '透明热区内嵌视频',
        value: 3,
      },
    ],
  },
  {
    text: '展示播放按钮',
    name: 'showPlayIcon',
    inputType: 'switch',
    defaultValue: true,
  },
  {
    text: '播放自动全屏',
    name: 'showFullScreen',
    inputType: 'switch',
    defaultValue: false,
  },
  {
    name: 'videoConfig',
    items: [
      {
        text: 'vid',
        name: 'vid',
        onChange(vm, v, { formValue }) {
          if (formValue?.report?.expose) {
            formValue.report.expose.vid = v;
          }
          if (formValue?.report?.click) {
            formValue.report.click.vid = v;
          }
        },
      },
      {
        text: '视频封面图片',
        name: 'poster',
        inputType: 'upload',
        drag: true,
        placeholder: '如需自动获取可不填',
      },
      {
        text: '自动播放',
        name: 'autoplay',
        inputType: 'switch',
        defaultValue: false,
      },
      {
        text: '隐藏UI控件',
        extra: '将会隐藏控制栏，画中画等播放器控件',
        name: 'isHideUIControl',
        inputType: 'switch',
        defaultValue: false,
      },
      {
        text: '禁止点击暂停/播放',
        extra: '选中之后，点击视频将无法暂停和恢复播放',
        name: 'isDisableInteractMod',
        inputType: 'switch',
        default: false,
      },
      {
        text: '视频平铺方式',
        extra: '用于指定视频平铺的方式，可以选择默认、填充或者覆盖',
        name: 'videoObjectFit',
        inputType: 'select',
        defaultValue: 'contain',
        options: [{
          text: '默认（保留原始长宽比，可能会有黑边）',
          value: 'contain',
        }, {
          text: '填充（正好铺满容器，不保留长宽比，可能会拉伸视频）',
          value: 'fill',
        }, {
          text: '覆盖（保留长宽比，以此铺满整个容器，可能会裁剪视频）',
          value: 'cover',
        }],
      },
    ],
  },
  {
    name: 'loopPlayConfig',
    items: [
      {
        text: '循环播放',
        name: 'isLoopPlay',
        inputType: 'switch',
        defaultValue: false,
      },
      {
        text: '循环次数',
        name: 'loopPlayCount',
        inputType: 'select',
        display: (vm, { model }) => model.isLoopPlay,
        options: [
          {
            text: '5次',
            value: 5,
          },
          {
            text: '10次',
            value: 10,
          },
          {
            text: '50次',
            value: 50,
          },
          {
            text: '100次',
            value: 100,
          },
          {
            text: '无限次',
            value: Infinity,
          },
          {
            text: '自定义次数',
            value: 'custom',
          },
        ],
        defaultValue: 10,
      },
      {
        text: '循环次数',
        name: 'customLoopPlayCount',
        defaultValue: 10,
        append: '次',
        display: (vm, { model }) => model.isLoopPlay && model.loopPlayCount === 'custom',
      },
    ],
  },
  {
    type: 'component',
    id: 'devConfig',
  },
  {
    type: 'component',
    id: 'rect',
  },
];
